if ( typeof CollectionTabs !== 'function' ) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const tabs = this.querySelectorAll('.collection-tabs_tab');
      const panels = this.querySelectorAll('.collection-tabs_panel');
      const viewCollectionLink = this.querySelector('.section-heading__actions a');
      const viewCollectionLink2 = this.querySelector('.js-view-collection-link');
      const headingWrapper = this.querySelector('.js-collection-heading');
      const headingTitle = headingWrapper ? headingWrapper.querySelector('.section-heading__title') : null;
      const headingSubheading = headingWrapper ? headingWrapper.querySelector('.section-heading__subheading') : null;

      const updateHeading = (button) => {
        if (!headingWrapper) return;
        
        const heading = button.getAttribute('data-heading');
        const subheading = button.getAttribute('data-subheading');
        
        // Update heading
        if (headingTitle && heading) {
          headingTitle.textContent = heading;
        }
        
        // Update subheading - handle case where element might not exist
        const currentSubheading = headingWrapper.querySelector('.section-heading__subheading');
        const subheadingText = headingWrapper.querySelector('.section-heading__text');
        
        if (subheading && subheadingText) {
          if (currentSubheading) {
            currentSubheading.textContent = subheading;
          } else {
            // Create subheading element if it doesn't exist
            const subheadingEl = document.createElement('span');
            subheadingEl.className = 'section-heading__subheading text-size--large';
            subheadingEl.textContent = subheading;
            subheadingText.appendChild(subheadingEl);
          }
        } else if (currentSubheading && !subheading) {
          // Remove subheading if it exists but new one is blank
          currentSubheading.remove();
        } else if (currentSubheading && subheading) {
          currentSubheading.textContent = subheading;
        }
      };

      tabs.forEach(tab => {

        tab.addEventListener('click', e => {

          e.preventDefault(); 

          tabs.forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(panel => {
            panel.classList.remove('active');
            panel.setAttribute('aria-hidden', 'true')
          });

          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');

          const button = tab.querySelector('button');
          const targetPanelId = button.getAttribute('aria-controls');
          const collectionUrl = button.getAttribute('data-collection-url');
          
          // Update heading and subheading
          updateHeading(button);
          
          if ( viewCollectionLink && collectionUrl ) {
            viewCollectionLink.setAttribute('href', collectionUrl);
          }
          if ( viewCollectionLink2 && collectionUrl ) {
            viewCollectionLink2.setAttribute('href', collectionUrl);
          }

          panels.forEach(panel => {
            if (panel.id === targetPanelId) {
              panel.classList.add('active');
              panel.removeAttribute('aria-hidden');
              const slider = panel.querySelector('css-slider');
              if ( slider ) {
                slider.resetSlider();
              }
            }
          });
        });
      });

      // Make active first collection in the list and set initial heading
      if ( tabs.length > 0 && panels.length > 0 ) {
        tabs[0].classList.add('active');
        tabs[0].setAttribute('aria-selected', 'true');
        const firstButton = tabs[0].querySelector('button');
        if (firstButton) {
          updateHeading(firstButton);
        }
      }
    }

  }

  if ( typeof customElements.get('collection-tabs') == 'undefined' ) {
    customElements.define('collection-tabs', CollectionTabs);
	}

  document.addEventListener('shopify:section:load', (e)=>{
    if ( e.target.classList.contains('mount-collection-tabs') ) {
      e.target.querySelector('collection-tabs')?.init();
    }
  });

}